import { render, staticRenderFns } from "./homepage4.vue?vue&type=template&id=3b1125f6&scoped=true&"
import script from "./homepage4.vue?vue&type=script&lang=js&"
export * from "./homepage4.vue?vue&type=script&lang=js&"
import style0 from "./homepage4.vue?vue&type=style&index=0&id=3b1125f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1125f6",
  null
  
)

export default component.exports